import api from '../../api/dentalsolutioncompanies'

// initial state
const state = {
    dentalSolutionCompanies:
    {
        root: [],
        totalCount: 0
    },
    saveOrdinationResponse: false,
    deleteOrdinationResponse: false
}

// getters
const getters = {
    dentalSolutionCompanies: state => state.dentalSolutionCompanies,
}

// actions
const actions = {
    getDentalSolutionCompanies: function(context, data)
    {
        api.getDentalSolutionCompanies(data, companies =>
        {
            context.commit('receiveCompanies', companies)
        })
    },
}

// mutations
const mutations = {
    receiveCompanies(state, companies)
    {
        companies.totalCount = parseInt(companies.totalCount)
        state.dentalSolutionCompanies = companies
    },
}

export default
{
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/dentalsolutioncompanies.js